import { Injector } from '@angular/core';
import { SCATTER_PLOT_APP_STATE_SLICE_KEY, SCATTER_PLOT_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { ScatterPlotUrlDeserializer } from 'ChartApp/ts/apps/scatter-plot/scatter-plot.serializers';
import * as i0 from "@angular/core";
export class ScatterPlotAppStateManager extends AppStateManager {
    // AppStateService is lazily resolved to avoid a circular dependency: this service is
    // providedIn: 'root' and AppStateService depends on ActivatedRoute, which isn't available
    // on pages without a Router.
    constructor(injector) {
        super(null);
        this.injector = injector;
    }
    resolveAppStateService() {
        if (this.appStateService === null) {
            this.appStateService = this.injector.get(AppStateService, null);
        }
    }
    initAppState() {
        this.resolveAppStateService();
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(SCATTER_PLOT_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(SCATTER_PLOT_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(ScatterPlotUrlDeserializer);
        this.appStateService.start();
    }
}
ScatterPlotAppStateManager.ɵfac = function ScatterPlotAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotAppStateManager)(i0.ɵɵinject(i0.Injector)); };
ScatterPlotAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ScatterPlotAppStateManager, factory: ScatterPlotAppStateManager.ɵfac, providedIn: 'root' });
